import { AbstractDTO } from '../abstract';
import { VisibilityOnDependFailure } from '@signature-it/ngx-generic/enums';

export class FormField extends AbstractDTO {
	questionId: number;
    value: any;
    key: string;
    label: string;
	labelFm: string;
	fieldLabel: string;
    info: string;
    explain: string;
	explainFm: string;
    required: boolean;
    order: number;
    stepId: number;
    stepOrder: number;
    controlType: string;
    type: string;
    validator: string;
    validatorMsg: string;
    extraData: any;
	allowSkip: boolean;
	visibilityOnDependFailure: string;
	deleteAnswerOnDependFailure: boolean;
    attrForAns: any;
	dynamicOptions: boolean;
	searchable: boolean;
    labelClass: string;
    fieldClass: string;
    isFictive: boolean;
    isHelper: boolean;
	ignoreInAns: boolean;
    readOnly: boolean;
    hideWhenEmpty: boolean;
	updateValuesByOtherAns: boolean;
	defaultJs: string;
	defaultJsDependFields: [];
	disableJs: string;
    additionalInfo: string;
	dependJs: string;
    validatorJs: string;
	reloadWhenStepIsActive: string;
	class: string;
	line: string;
    parentStepHasDependRule: boolean;
    isHidden: boolean;
    asyncLoading: boolean;
    cngId: number;
    requiredJs: string;
    isShowBrowserAutocomplete: boolean;
    placeHolder: string;
    searchSelect: boolean;
    explainIcon: string;
    explainPosition: string;
    questionFieldName: string;
    hideInFront: boolean;
    isDisabled: boolean;
    showClearAnsIcon: boolean;
    isUnique: boolean;
    inheritedField: boolean;
    aiAssistance: boolean;
    aiInstructions: boolean;

    constructor(attributes?: Object) {
        super(attributes);
        this.questionId = attributes['questionId'];
        this.value = attributes['value'];
        this.key = attributes['key'] || '';
        this.label = attributes['label'] || '';
        this.labelFm = attributes['labelFm'] || '';
        this.fieldLabel = attributes['fieldLabel'] || '';
        this.info = attributes['info'] || '';
        this.explain = attributes['explain'] || '';
        this.explainFm = attributes['explainFm'] || '';
        this.required = !!attributes['required'];
        this.order = attributes['order'] === undefined ? 1 : attributes['order'];
        this.stepId = attributes['stepId'];
        this.stepOrder = attributes['stepOrder'] === undefined ? 0 : attributes['stepOrder'];
        this.controlType = attributes['controlType'] || '';
        this.type = attributes['type'] || '';
        this.validator = attributes['validator'] || '';
        this.validatorMsg = attributes['validatorMsg'] || '';
        this.extraData = attributes['extraData'] || {};
        this.allowSkip = attributes['allowSkip'] || false;
        this.visibilityOnDependFailure = attributes['visibilityOnDependFailure'] || VisibilityOnDependFailure.HIDE_QUESTION;
        this.deleteAnswerOnDependFailure = attributes['deleteAnswerOnDependFailure'] || false;
        this.attrForAns = attributes['attrForAns'];
        this.dynamicOptions = attributes['dynamicOptions'] || false;
        this.searchable = attributes['searchable'] || false;
        this.labelClass = attributes['labelClass'] || '';
        this.fieldClass = attributes['fieldClass'] || '';
        this.isFictive = attributes['isFictive'] || false;
        this.isHelper = attributes['isHelper'] || false;
        this.ignoreInAns = attributes['ignoreInAns'] || false;
        this.readOnly = attributes['readOnly'] || false;
        this.hideWhenEmpty = attributes['hideWhenEmpty'] || false;
        this.updateValuesByOtherAns = attributes['updateValuesByOtherAns'] || false;
        this.defaultJs = attributes['defaultJs'] || '';
        this.defaultJsDependFields = attributes['defaultJsDependFields'] || [];
        this.disableJs = attributes['disableJs'] || '';
        this.additionalInfo = attributes['additionalInfo'] || '';
        this.dependJs = attributes['dependJs'] || '';
        this.validatorJs = attributes['validatorJs'] || '';
		this.reloadWhenStepIsActive = attributes['reloadWhenStepIsActive'] || false;
		this.class = attributes['class'] || '';
		this.line = attributes['line'] || '';
        this.parentStepHasDependRule = attributes['parentStepHasDependRule'] || false;
        this.isHidden = attributes['isHidden'] || false;
        this.asyncLoading = attributes['asyncLoading'] || false;
        this.cngId = attributes['cngId'] || 0;
        this.requiredJs = attributes['requiredJs'] || '';
        this.isShowBrowserAutocomplete = attributes['isShowBrowserAutocomplete'] || true;
        this.placeHolder = attributes['placeHolder'] || '';
        this.searchSelect = attributes['searchSelect'] || false;
        this.explainIcon = attributes['explainIcon'] || 'fa fa-question-circle';
        this.explainPosition = attributes['explainPosition'] || 'top';
        this.questionFieldName = attributes['questionFieldName'] || '';
        this.hideInFront = attributes['hideInFront'] || false;
        this.isDisabled = attributes['isDisabled'] || false;
        this.showClearAnsIcon = attributes['showClearAnsIcon'] || false;
        this.isUnique = attributes['isUnique'] || false;
        this.inheritedField = attributes['inheritedField'] || false;
        this.aiAssistance = attributes['aiAssistance'] || false;
        this.aiInstructions = attributes['aiInstructions'] || '';
    }

    setValue(value, force: boolean = false) {
        if (FormField.isValidValue(value) || force) {
            this.value = value;
        }
    }

    getValue() {
		return FormField.isValidValue(this.value) ? this.value: '';
    }

	static isValidValue(v) {
        return v || v === '' || v === 0 || v  === '0';
    }



    getTitle(value) {
        return value;
    }

    getKey(value) {
        return value;
    }

}
